import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Close from '@/images/Close.svg';
import Warning from '@/images/WarningColored.svg';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Button, Dialog } from '@mui/material';
import { useEffect } from 'react';

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        padding: 24px;
        font-family: 'Manrope', sans-serif;
        color: ${theme.colors.black[800]};
        gap: 16px;
        width: 450px;
    }
`;

const Text = styled.h2`
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.48px;
    color: ${theme.colors.secondary.main};
`;

const Title = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;

    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
`;

const CloseButton = styled(MaskedIcon)`
    position: absolute;
    right: 16px;
    top: 16px;
`;

const MainText = styled.div`
    color: ${theme.colors.secondary['main']};
    font-size: 1.6rem;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.15px;
`;

const StyledIcon = styled.img``;

const StyledButton = styled(Button)<{ inverted?: boolean }>`
    background-color: ${({ inverted }) => (inverted ? 'white' : theme.colors.secondary.main)};
    color: ${({ inverted }) => (inverted ? theme.colors.secondary.main : 'white')};
    border: 1px solid ${theme.colors.secondary.main};
    width: 190px;

    display: flex;
    padding: 10px 0px;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;

    &:hover {
        background-color: ${({ inverted }) => (inverted ? '#eee' : theme.colors.secondary['700'])};
        color: ${({ inverted }) => (inverted ? theme.colors.secondary['700'] : '#eee')};
    }
`;

interface Props {
    isOpen?: boolean;
    onClose: () => void;
}

export const DeprecatedVoiceModal = ({ isOpen = false, onClose }: Props) => {
    const mixpanel = useAnalytics();

    useEffect(() => {
        if (isOpen) {
            mixpanel?.track('deprecated-agent-voice', { event: 'view' });
        }
    }, [isOpen]);

    return (
        <StyledDialog open={isOpen} onClose={onClose}>
            <CloseButton onClick={onClose} src={Close} size="12px" color="black" />
            <Title>
                <StyledIcon src={Warning} />
                <Text>Your Agent’s voice is deprecated</Text>
            </Title>
            <MainText>
                The voice you previously selected is no longer available, so we’ve replaced it with a similar option. You can change the
                voice from the list if needed.
            </MainText>
            <Title>
                <StyledButton onClick={onClose} style={{ textTransform: 'none' }}>
                    I understand
                </StyledButton>
            </Title>
        </StyledDialog>
    );
};
